import { toast } from 'sonner';
import type { ConsignmentBulkProcessResponse } from '@/entities/consignments';

interface ProcessBulkResultOptions {
  result: ConsignmentBulkProcessResponse;
  successMessage: (count: number) => string;
  errorMessage: string;
  warningMessage: (succeeded: number, total: number) => string;
}

export function processBulkResult({
  result,
  successMessage,
  errorMessage,
  warningMessage
}: ProcessBulkResultOptions): void {
  const failed = result.results.filter((r) => r.status === 'FAILED');
  const succeeded = result.results.filter((r) => r.status === 'SUCCESS');

  if (failed.length === 0) {
    toast.success(successMessage(succeeded.length));
  } else if (succeeded.length === 0) {
    toast.error(errorMessage);
  } else {
    toast.warning(warningMessage(succeeded.length, result.results.length));
  }
}
